


export default{
props:{
time: {
type: Number,
default: 2000
},
errMsg: {
type: String,
required: true
},
value: {
required: true,
type: Boolean
},
autoClose: {
type: Boolean,
default: false
}
},



data (){
return {
timer: null
}
},
methods: {
close(){
clearTimeout(this.timer);
this.$emit("input", false);
}
},
updated(){
if(this.value && this.autoClose){
clearTimeout(this.timer);
this.timer = setTimeout(() => {
this.$emit("input", false);
},this.time);
}
}
}



// WEBPACK FOOTER //
// ./src/components/topTip.vue